import {
  BlueBirdTheme, Typography,
} from "@kitbird/core";
import { toRupiah, toStringDate } from "../../../../../utils/common";
import { ColumnI } from "../../../../../components/Table/TableProps";
import { CommonTrxTypes } from "../../../../../enums/common";

const {
  gray,
} = BlueBirdTheme.colors;

const columns = (): ColumnI[] => [{
  title: "No. pengajuan bon",
  dataIndex: "trx_id",
  key: "trx_id",
  sort: true,
  width: "150px",
},
{
  title: "Tanggal pengajuan",
  dataIndex: "trx_date",
  key: "trx_date",
  sort: true,
  width: "160px",
  render: (item) => toStringDate(item),
},
{
  title: "Pemohon & NIP",
  dataIndex: "employee_id",
  key: "employee_id",
  sort: true,
  width: "125px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {row.employee_name}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {item}
      </Typography>
    </>
  ),
},
{
  title: "Total bon & tipe transaksi",
  dataIndex: "amount",
  key: "amount",
  sort: true,
  width: "175px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {toRupiah(item)}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {row.trx_desc}
      </Typography>
    </>
  ),
},
{
  title: "Deskripsi",
  dataIndex: "trx_text",
  key: "trx_text",
  sort: true,
  width: "225px",
},
{
  title: "Perusahaan & relasi",
  dataIndex: "company_code",
  key: "company_code",
  sort: true,
  width: "145px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item}
      </Typography>
      <br />
    </>
  ),
},
{
  title: "Akun GL",
  dataIndex: "trx_code",
  key: "trx_code",
  sort: true,
  width: "175px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {row.trx_code} • {CommonTrxTypes.find(
          (type) => type.value === row.sap_shkzg,
        )?.label}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {row.trx_desc}
      </Typography>
    </>
  ),
}];

export default columns;
